import { inject, Injectable } from '@angular/core';
import { ApiHelper } from '@core/api/api.helper';
import { ApiService } from '@core/api/api.service';
import { HttpResponse } from '@core/api/http-response.interface';
import { HttpStatusEnum } from '@core/api/http-status.enum';
import { FormatterHelper } from '@shared/helpers';
import { CurrentUser } from '@shared/types';

@Injectable({ providedIn: 'root' })
export class UserApi {
    private apiService = inject(ApiService);

    private readonly resourceUrl: string = `users`;

    getCurrentUserDetails(): Promise<HttpResponse<CurrentUser>> {
        return new Promise<HttpResponse<CurrentUser>>(resolve => {
            this.apiService.get(`${this.resourceUrl}/current-user-details`).subscribe({
                next: (res: any) => {
                    const data: CurrentUser = {
                        id: res.userId,
                        firstName: res.firstName,
                        lastName: res.lastName,
                        shortName: res.firstName + ' ' + (res.lastName ? res.lastName[0] + '.' : ''),
                        fullName: FormatterHelper.computeUserFullName(res.firstName, res.lastName),
                        email: res.email,
                        hasMarketingRole: res.hasMarketingRole,
                        omRoles: res.omRoles.map((role: { key: number; value: string }) => role.value),
                        timeZoneName: res.timeZone,
                    };
                    resolve({
                        isLoading: false,
                        status: HttpStatusEnum.SUCCESS,
                        data: data,
                    });
                },
                error: err => {
                    ApiHelper.resolveError(resolve, '');
                    console.error(err);
                },
            });
        });
    }
}
